import { Hash } from 'lucide-react';
import { HSNCodeList } from './HSNCodeList';
import { HSNCodeShow } from './HSNCodeShow';

// HSN/SAC codes are managed centrally via DB seed migrations (the master is a
// regulated GST catalogue, not per-user data) — manual create/edit screens were
// removed so the list stays read-only. Revisit if a live-API / full-master sync
// is funded later.
export const hsn_codes = {
    list: HSNCodeList,
    show: HSNCodeShow,
    icon: Hash,
    recordRepresentation: (record: any) => `${record.code} – ${record.description}`,
};

export { HSNCodeList, HSNCodeShow };
